import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepsModule } from 'primeng/steps';
import { SharedModule } from 'src/app/shared/shared.module';
import { TipoDocumentoComponent } from './components/tipo-documento.component';
import { NuovoComponent } from './nuovo.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    StepsModule,
    CardModule,
    ButtonModule
  ],
  exports: [
    NuovoComponent
  ],
  declarations: [
    NuovoComponent,
    TipoDocumentoComponent
  ],
  providers: [],
})
export class NuovoModule { }
